function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.is-array.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import chroma from 'chroma-js';
import { baseColorKeys } from "../color/schema";
import { defaultBaseColors, mapScalesToSemanticColors } from "../color/semanticColors";
/**
 * Validates the provided base colors object and returns a parsed version with
 * chroma.js color objects.
 */
function parseBaseColors(obj) {
  if (_typeof(obj) !== 'object' || obj === null) {
    // BaseColors is not an object or is null
    throw new Error('[CDS theme] Theme must be a non-null object');
  }
  var baseChromaColors = {};
  var _iterator = _createForOfIteratorHelper(baseColorKeys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      // Missing color value
      if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        throw new Error("[CDS theme] Theme object is missing required color: \"".concat(key, "\""));
      }

      // Color value is not a string
      if (typeof obj[key] !== 'string') {
        throw new Error("[CDS theme] Color \"".concat(key, "\" must be a string"));
      }
      var colorValue = obj[key];
      baseChromaColors[key] = getChromaColor(key, colorValue);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return baseChromaColors;
}

/**
 * Returns a base Chroma color object from the provided token and color.
 */
function getChromaColor(token, color) {
  var validatedColor = color;

  // eslint-disable-next-line import/no-named-as-default-member
  if (!chroma.valid(color)) {
    console.warn("[Theme generator] Invalid value provided for ".concat(token, " color: ").concat(color, ". Reverting to default."));
    validatedColor = defaultBaseColors[token];
  }
  return chroma(validatedColor);
}

/**
 * Generates a set of semantic color tokens giving the provided base colors.
 */
export function generateThemePalette(baseColors) {
  var parsedBaseColors = parseBaseColors(baseColors);
  var colorScales = {
    // These are hardcoded to prevent a11y contrast issues
    inverted: '#fff',
    background: '#fff'
  };
  Object.entries(parsedBaseColors).forEach(function (colorItem) {
    var _colorItem = _slicedToArray(colorItem, 2),
      token = _colorItem[0],
      baseColor = _colorItem[1];
    var darkColor = baseColor.mix('#000', 0.85, 'lab');
    var customLightTints = {
      primary: '#FFF',
      secondary: '#F6F8FE',
      positive: '#E9F5F2',
      negative: '#FEF6F8',
      warning: '#FFFFE6',
      magic: '#FBF6FE'
    };
    var lightTint = customLightTints[token];
    var lightColor = token === 'primary' ? baseColor.mix(lightTint, 0.95) : token === 'warning' ? baseColor.mix(lightTint, 0.96).desaturate(0.2) : baseColor.mix(lightTint, 0.95, 'lab').brighten(0.2);

    // eslint-disable-next-line import/no-named-as-default-member
    var colorScale = chroma.scale([darkColor, baseColor, lightColor]).mode(token === 'primary' ? 'rgb' : token === 'warning' ? 'hsl' : 'lab').colors(21);
    colorScale.forEach(function (scaleValue, index) {
      colorScales["".concat(token).concat(String(index + 1).padStart(2, '0'))] = scaleValue;
    });
  });
  var colors = mapScalesToSemanticColors(colorScales);

  // colorScales is returned just for reference, to be used on the theme generator
  return {
    colorTokens: colors,
    colorScales: colorScales
  };
}